import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ShareModal from '../../components/Share/ShareModal';
import { getVrrPreferences } from '../../redux/settings/settingAction';
import { fetchViewers } from '../../redux/overview/overviewActions';
import { addViewer } from '../../redux/userPreferences/actions/userPreferencesAPIs';
import { TShareContainer } from './types';

export const ShareContainer: React.FC<TShareContainer> = ({
  isOpen,
  onCancelAction
}) => {
  const dispatch: any = useDispatch();
  const brandId = useSelector(getVrrPreferences)?.current_brand_id;

  useEffect(() => {
    if (brandId && isOpen) {
      dispatch(fetchViewers({ brandId }));
    }
  }, [brandId, isOpen]);

  const handleSubmit = (emails: string[], updateViewersSettings: boolean) => {
    if (emails.length > 0 || updateViewersSettings) {
      dispatch(addViewer({ emails, updateViewersSettings }));
      if (onCancelAction) onCancelAction();
    }
  };

  const handleCancel = () => {
    if (onCancelAction) onCancelAction();
  };

  return (
    <ShareModal
      isOpen={isOpen}
      onSubmit={handleSubmit}
      onCancel={handleCancel}
    />
  );
};

export default ShareContainer;
